<template>
  <div class="Main-Inner">
    <div class="Main-Content">
      <Page title="Help & Support" style="background-color: #eee;">
        <Layout>
          <LayoutSection>
            <Card title="Documentation">
              <CardSection>
                <TextContainer>
                  <div>Extensive documentation for primary areas of the portal, including Insights, Campaigns and Creative are available here:</div>
                  <a href="#/redirectProtectedContent/?url=https%3A%2F%2Fprotected.fanplayr.com%2Fdocs%2Fportal%2Findex.html" target="_blank">Portal Documentation </a>
                </TextContainer>
              </CardSection>
            </Card>

            <Card title="Developer & Support Tools">
              <CardSection>
                <TextContainer>
                  <div>This bookmarklet will allow you to view or delete your current Fanplayr session which can be helpful when testing your segmentation configuration. Please note that you must be viewing your website when using this tool.</div>
                  <div>To add this tool to your browser, click & drag the bookmarklet below to your browser's bookmark toolbar:</div>

                  <a
                    href="javascript:(function(){var api=window.fanplayr_dt;if(api){api.toggle();return;}var e=document.createElement('script');e.type='text/javascript';e.async=true;e.src='//fanplayr.s3.amazonaws.com/browser-dev-tools/loader.js';var t=document.getElementsByTagName('head')[0]||document.getElementsByTagName('body')[0];if(t){t.appendChild(e)}})()"
                    class="bookmark"
                  >
                    <Icon icon="fas fa-bookmark" />
                    Fanplayr Tools
                  </a>

                </TextContainer>
              </CardSection>

              <CardSection v-if="!isProduction">
                <TextContainer>
                  <div>For internal use only. This will open the Session Viewer on Stage.</div>
                  <div>To add this tool to your browser, click & drag the bookmarklet below to your browser's bookmark toolbar:</div>

                  <a
                    href="javascript:(function()%7Btry%20%7Bvar%20key%20%3D%20fanplayr.platform.config.sessionKey%3Bif%20(!key)%20%7Balert('Fanplayr%20not%20loaded%20on%20website%20yet')%3B%7D%20else%20%7Bvar%20url%20%3D%20'https%3A%2F%2Fstage.fanplayr.com%2F%23%2FsessionViewer%2F%3Fsk%3D'%20%2B%20key%3Bwindow.open(url)%3B%7D%7D%20catch%20(ex)%20%7Balert('Fanplayr%20not%20on%20website')%3B%7D%7D)()"
                    class="bookmark"
                  >
                    <Icon icon="fas fa-bookmark" />
                    Fanplayr Stage Session
                  </a>

                </TextContainer>
              </CardSection>
            </Card>

            <Card title="Contact Support">
              <CardSection>
                <TextContainer>
                  <div>Having trouble setting up a campaign or getting it onto your site?</div>
                  <div>Email us at at <a href="mailto:support@fanplayr.com">support@fanplayr.com</a> we'll help you right away.</div>
                </TextContainer>
              </CardSection>
            </Card>
          </LayoutSection>
        </Layout>
      </Page>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Support',
  data() {
    return {
      isProduction: false
    }
  },
  mounted() {
    this.isProduction = window.location.hostname === 'portal.fanplayr.com'
  }
}
</script>

<style lang="scss" scoped>
.bookmark {
  color: #fff;
  background-color: #337ab7;
  border-color: #2e6da4;
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
}
</style>